import { UnwrapHelper } from '../UnwrapHelper';
export class UnwrapTransactionHelper extends UnwrapHelper {
}

//# sourceMappingURL=UnwrapTransactionHelper.js.map
